<template>
  <div class="login-container">
    <h2>手机号登录</h2>
    <div class="form-group">
      <input type="tel" v-model="phone" placeholder="请输入手机号" @input="validatePhone" />
    </div>
    <div class="form-group-inline">
      <input type="text" v-model="verificationCode" placeholder="请输入验证码" />
      <button @click="sendCode" :disabled="!isPhoneValid || countdown > 0">
        {{ countdown > 0 ? `${countdown}s 后重发` : '发送验证码' }}
      </button>
    </div>
    <div class="form-group">
      <button class="login-btn" @click="login" :disabled="!isLoginButtonEnabled">登录</button>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5';
import mockApi from '../api/mock';

export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      verificationCode: '',
      generatedCode: null, // 本地生成的验证码，用于校验
      isPhoneValid: false,
      countdown: 0,
      timer: null,
    };
  },
  computed: {
    // 登录按钮是否可用
    isLoginButtonEnabled() {
      // return this.verificationCode.length === 6 && this.generatedCode !== null && this.verificationCode === this.generatedCode;
      return true;
    }
  },
  methods: {
    // 1a: 手机号校验
    validatePhone() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      this.isPhoneValid = phoneRegex.test(this.phone);
    },
    
    // 1b, 1c: 发送验证码
    async sendCode() {
      if (!this.isPhoneValid) return;

      // 1b: 生成6位随机验证码
      this.generatedCode = String(Math.floor(100000 + Math.random() * 900000));
      this.generatedCode = '123678';
      console.log(`生成的验证码 (用于测试): ${this.generatedCode}`);

      // 1b: 与复杂字符串拼接并计算 MD5
      const complexString = "a-random-secret-salt-string-for-security";
      const hash = md5(this.generatedCode + complexString);
      
      try {
        // 1b: 发送到后台 API
        const response = await mockApi.sendVerificationCode(hash);
        if (response.success) {
        //   alert('模拟验证码已发送，请在控制台查看。');
          // 1c: 开始倒计时
          this.countdown = 60;
          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } catch (error) {
        console.error("发送验证码失败:", error);
        alert('发送验证码失败，请稍后重试。');
      }
    },
    
    // 1d: 登录
    login() {
      if (!this.isLoginButtonEnabled) {
        alert("验证码不正确！");
        return;
      }
      
      // 登录成功
      console.log("登录成功！");
      
      // 生成一个假的 token 并保存到 localStorage
      const fakeToken = `fake-token-${Date.now()}`;
      localStorage.setItem('authToken', fakeToken);
      
      // 跳转到监控页
      this.$router.push('/monitor');
    }
  },
  // 1e: 页面创建时检查 token
  created() {
    if (localStorage.getItem('authToken')) {
      this.$router.push('/monitor');
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped>
.login-container { max-width: 400px; margin: 100px auto; padding: 20px; border: 1px solid #ccc; border-radius: 8px; }
.form-group { margin-bottom: 15px; }
.form-group-inline { display: flex; justify-content: space-between; margin-bottom: 20px; }
.form-group-inline input { flex-grow: 1; margin-right: 10px; }
input { width: 100%; padding: 10px; box-sizing: border-box; }
button { padding: 10px 15px; cursor: pointer; }
button:disabled { cursor: not-allowed; background-color: #ccc; }
.login-btn { width: 100%; background-color: #42b983; color: white; border: none; }
</style>